import Button from '@/components/Button';
import ensureSelectedFilterOptions from '@/components/modals/workflowLogsModal/lib/ensureSelectedFilterOptions';
import useWorkflowLogsFilters from '@/components/modals/workflowLogsModal/lib/useWorkflowLogsFilters';
import { RxLightningBolt } from '@/components/react-icons/main/index.esm';
import FloatingSelectV2 from '@/components/v2/FloatingSelectV2';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors.js';
import selectors from '@/redux/selectors/selectors';
import { workflowStatusMap } from '@shared/schema/workflowStatusMap.js';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const StatusFilter = () => {
  const workflowId = useArgSelector(selectors.workflowId);
  const statusFilter = useArgSelector(selectors.pref, `workflowLogsStatusFilter-${workflowId}`);
  const workflowLogsMetadataStatuses = useSelector(selectors.workflowLogsMetadataStatuses);
  const { handleFilterChange } = useWorkflowLogsFilters();

  const hasStatusFilter = statusFilter?.length > 0;

  const statusOptions = useMemo(() => {
    const options = workflowLogsMetadataStatuses
      ?.map((metadata) => {
        return { label: workflowStatusMap[metadata?.id], value: metadata?.id, totalCount: metadata?.totalCount };
      })
      ?.sort((a, b) => b.totalCount - a.totalCount);

    return ensureSelectedFilterOptions({
      options,
      selectedValues: statusFilter,
      getSelectedOption: (value) => ({ label: workflowStatusMap[value] || value })
    });
  }, [workflowLogsMetadataStatuses, statusFilter]);

  const handleStatusChange = (value) => {
    handleFilterChange('status', value);
  };

  return (
    <>
      <Button className={`outline filter status-filter ${hasStatusFilter ? 'active' : ''}`} size="sm" icon={RxLightningBolt}>
        Status
      </Button>
      <FloatingSelectV2 multiple triggers={[`.status-filter`]} options={statusOptions} onChange={handleStatusChange} useSearch={statusOptions?.length > 5} value={statusFilter} placement="bottom" offset={4} />
    </>
  );
};

export default StatusFilter;
